// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__oHpdK","list":"PatternAutocomplete_list__svlsx"};